import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ApiOutlinedSvg from "@ant-design/icons-svg/es/asn/ApiOutlined";
import AntdIcon from "../components/AntdIcon";
var ApiOutlined = function ApiOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ApiOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ApiOutlined.displayName = 'ApiOutlined';
}
export default /*#__PURE__*/React.forwardRef(ApiOutlined);